<template>
  <div>
    <!--    <el-row>-->
    <!--      <el-col :span="24">-->
    <!--        <el-form inline size="mini" :model="searchCondition">-->
    <!--          <el-form-item>-->
    <!--            <el-input v-model="searchCondition.order_no" placeholder="订单编号" clearable>-->
    <!--              <template slot="append">-->
    <!--                <el-button @click="getList" type="primary">搜索</el-button>-->
    <!--              </template>-->
    <!--            </el-input>-->
    <!--          </el-form-item>-->
    <!--        </el-form>-->
    <!--      </el-col>-->
    <!--    </el-row>-->
    <el-row>
      <el-col :span="24">
        <el-card>
          <div class="default-table">
            <el-table :data="dataList">
              <el-table-column type="index" label="序号"></el-table-column>
              <!--              <el-table-column label="ID" prop="id" width="55"></el-table-column>-->
              <el-table-column label="订单编号" prop="order_no" width="140"></el-table-column>
              <el-table-column label="操作类型" prop="type_alias" width="100"></el-table-column>
              <el-table-column label="操作人" prop="creator" width="120"></el-table-column>
              <el-table-column label="操作内容" prop="description" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作时间" prop="created_at" width="140"></el-table-column>
              <!--              <el-table-column label="操作项"  width="100">-->
              <!--                <template>-->
              <!--                  <el-button type="text">详情</el-button>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
            </el-table>
            <pagination :total.sync="total" :page.sync="pageData.page" :limit.sync="pageData.per_page"
                        @pagination="getList"/>
          </div>
        </el-card>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getOrderLogs} from "@/api/adOrder";
import {getPukeOrderLogs} from "@/api/regulars";

export default {
  name: "OrderLogs",
  props: {
    orderNo: {
      type: String,
      default() {
        return null
      }
    },
    orderType: {
      type: String,
      default() {
        return 'isMark'
      }
    }
  },
  data() {
    return {
      searchCondition: {order_no: ''},
      dataList: [],
      total: 0,
      pageData: {per_page: 10, page: 1}
    }
  },
  methods: {
    async getList() {
      let searchCondition = this.searchCondition
      Object.assign(searchCondition, this.pageData)
      if (this.orderType === 'puke') {
        let {list, total} = await getPukeOrderLogs(searchCondition).then(res => {
          return res.model
        })
        this.dataList = list
        this.total = total
      } else {
        let {list, total} = await getOrderLogs(searchCondition).then(res => {
          return res.model
        })
        this.dataList = list
        this.total = total

      }

    }
  },
  mounted() {
    this.searchCondition.order_no = this.orderNo
    // this.getList()
  }
}
</script>

<style scoped>

</style>
